export const TEXT_RENDERER = 'text';
export const STATUS_RENDERER = 'status';
export const DURATION_RENDERER = 'duration';
export const NUMBER_RENDERER = 'number';
export const DATE_RENDERER = 'date';
export const HTML_RENDERER = 'html';
export const URL_RENDERER = 'url';

export const THUMBNAIL_SYSTEM_FIELD_ID = 'thumbnail';
